
import React, { useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import { ToastComponent } from '@syncfusion/ej2-react-notifications';
import { useTranslation } from 'react-i18next';
import { outboxMessageProcessed } from '../../actions/application';
import { editMessageAsNew } from '../../services/application';

const MessageSnackbar = ({ outbox }) => {
  const toastRef = useRef(null);
  const { t } = useTranslation();

  useEffect(() => {
    if (!outbox || !toastRef.current) return;

    toastRef.current.hide('All');

    if (outbox.sent) {
      toastRef.current.show({
        content: t('messageSnackbar.messageSent'),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      });
    } else if (!outbox.sent && outbox.error) {
      toastRef.current.show({
        content: t('messageSnackbar.messageError'),
        cssClass: 'e-toast-danger',
        icon: 'lf-icon lf-icon-close-round'
      });
    } else if (outbox) {
      toastRef.current.show({
        content: t('messageSnackbar.sendingMessage', {
          progress: outbox.progress * 100
        }),
        cssClass: 'e-toast-success',
        icon: 'lf-icon lf-icon-check-round'
      });
    }
  }, [outbox, t]);

  useEffect(() => {
    // Cleanup function to safely destroy the toast component
    const toastInstance = toastRef.current;
    return () => {
      if (toastInstance) {
        try {
          toastInstance.hide('All');
          // Give time for animations to complete before destroying
          setTimeout(() => {
            if (toastInstance && toastInstance.destroy) {
              toastInstance.destroy();
            }
          }, 100);
        } catch (error) {
          // Silently handle any cleanup errors
          console.warn('Toast cleanup error:', error);
        }
      }
    };
  }, []);

  return (
    <ToastComponent
      ref={toastRef}
      id="toast_pos"
      position={{ X: 'Right', Y: 'Top' }}
      animation={{
        hide: { duration: '1' },
        show: { duration: '200' }
      }}
      timeOut={7000}
      showCloseButton
    />
  );
};


const mapStateToProps = state => ({
  outbox: state.application.outbox,
  draft: state.application.draft
});


const mapDispatchToProps = dispatch => ({
  retry: outbox => {
    editMessageAsNew(dispatch, outbox.message);
    dispatch(outboxMessageProcessed());
  }
});


const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps, {
    retry: () => dispatchProps.retry(stateProps.outbox)
  });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(MessageSnackbar);
